import { Training } from '../models/training';
import { TrainingCourse } from '../models/trainingCourse';

export const isCourse = (training: Training): training is TrainingCourse => training.type === 'course';
